import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'titleName',
    fieldName: '发票抬头'
  }, {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'customerCompany',
    fieldName: '客户公司'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'taxId',
    fieldName: '税号'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'registeredAddress',
    fieldName: '注册地址'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'bank',
    fieldName: '开户银行'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'account',
    fieldName: '银行账号'
  },
  //  {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'addressDetail',
  //   fieldName: '详细地址'
  // },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'phone',
    fieldName: '电话号码'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'createUser',
    fieldName: '创建人'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'updateUser',
    fieldName: '修改人'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'createTime',
    fieldName: '创建时间'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'updateTime',
    fieldName: '申请时间',
    width: 160
  }
]
